<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="mySocketTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading"  :rowKey="(record,index)=>{return index}">
            <template slot="operation" slot-scope="text, record">
                <!-- <router-link class="tableLink" :to="{path:'detail_templete',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink"  :to="{path:'edit_templete',query: {id: record.id,}}">编辑</router-link> -->
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
            </template>

            <template slot="status_name" slot-scope="text">
                <span :style="{color:text == '01' ? 'red' : 'green'}">{{ text == '01' ? '未回执' : '已发送' }}</span>
            </template>

            <!-- 业务埋点Attrabutes -->
            <template slot="jsonParams" slot-scope="text,record">
                <a-icon style="color:#1890ff;" size="large" type="file-text" @click="handleParamsJson(record)" />
            </template>

            <!-- 业务埋点Attrabutes -->
            <template slot="jsonParamsData" slot-scope="text,record">
                <a-icon style="color:#1890ff;" size="large" type="file-text" @click="handleParamsJsonData(record)" />
            </template>

            <template slot="onlineType" slot-scope="text">
                <span :style="{color:text == '0' ? 'red' : 'green'}">{{ text == '1' ? '在线' : '离线' }}</span>
            </template>

            <template slot="platforms" slot-scope="text">
               <span v-if="platforms.filter((n) => {return n.platformtype == text} ).length > 0">
                   {{ platforms.filter((n) => {return n.platformtype == text} )[0].platformtypename }}
               </span>
              <span v-else>--</span>
            </template>
        </a-table>
        <a-modal v-model="jsonModalVisable" width="600px" title="attributes">
                <json-viewer
                :value="jsonVData"
                :expand-depth=5
                copyable
                boxed
                sort></json-viewer>
            </a-modal>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};
import JsonViewer from "vue-json-viewer"
// branchcode: "001"
// createtime: "2021-11-22 20:08:21.0"
// deviceno: "625801367_001_4a7b8d84-e009-48c5-8d35-3eaadc18987f_1"
// platformtype: "PLATFROM-002"
// shopcode: "625801367"
// updatetime: "2021-12-08 10:47:03.0"
// userid: "3653"
const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        },
    },
    {
        title: "商户号",
        dataIndex: "shopcode",
        width:100,
        ellipsis: true,
        align:'center'
    },
    {
        title: "门店号",
        dataIndex: "branchcode",
        width:80,
        align:'center',
        ellipsis: true
    },
    {
        title: "用户ID",
        dataIndex: "userid",
        width:80,
        ellipsis: true,
        align:'center'
    },
    {
        title: "设备号",
        dataIndex: "deviceno",
        width:400,
        ellipsis: true
    },
    {
        title: "平台类型",
        dataIndex: "platformtype",
        scopedSlots: { customRender: 'platforms' },
        width:120,
        align:'center'
    },
    {
        title: "客户端编码",
        dataIndex: "appcode",
        width:120,
        ellipsis: true
    },
    {
        title: "会话ID",
        dataIndex: "sessionid",
        width:120,
        ellipsis: true
    },
    {
        title: "今日离线次数",
        dataIndex: "offlinecount",
        width:150,
        align:'center'
    },
    {
        title: "RS是否在线",
        dataIndex: "redisisonline",
        scopedSlots: { customRender: 'onlineType' },
        width:100,
        align:'center'
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        width:160,
        align:'center'
    },
    {
        title: "更新时间",
        dataIndex: "updatetime",
        width:160,
        align:'center'
    },
    {
        title: "操作",
        dataIndex: "updatetime",
        scopedSlots:{ customRender:'operation' },
        width:100,
        align:'center'
    },

];
export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            orderstr:'desc',
            jsonModalVisable:false,
            searchP:{},
            jsonVData:[],
            platforms:[]
        };
    },
    methods: {
        handleParamsJson(item){
            this.jsonVData = item.devicelist.split(',')
            this.jsonModalVisable = true;
        },
        handleParamsJsonData(item){
            this.jsonVData = JSON.parse(item.content)
            this.jsonModalVisable = true;
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleDelete(record){
            let that = this;
            that.$store.dispatch({
                type: "mcmsmanager/deleteDevice",
                params: {deviceno: record.deviceno}
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
        },
        getAppSumData(){
            let that = this
            that.tloading = true;
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "mcmsmanager/querydevicepage",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.tableData = result.list;
                    that.pagination.total = parseInt(result.totalRecords);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        },
        getPlatforms() {
            let that = this;
            let c_params = {
                urlparams: false,
            }
            that.$store.dispatch({
                type: "mcmsmanager/platforms",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    that.platforms = [];
                    let result = res.data.data;
                    if(!result){
                        that.message.error("未查询到平台");
                        return;
                    }
                    that.platforms = result;
                }
            }).catch(() => {

            });
        }
    },

    components:{
        JsonViewer
    },
    mounted(){
        this.getPlatforms();
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

